import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../common/component/Index";
import MarkupBundle from './../../../../../models/MarkupBundle';
import { withTranslation } from "react-i18next";
import { Icon, Menu, Table } from 'antd';
import { DATE_TIME_FORMAT, PATHS } from '../../../../../constants/Define';
import moment from "moment";
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { toArray } from 'lodash'
import EllipsisText from '../../../common/component/EllipsisText';
import Span from '../../../common/component/Span';
import { generateStringId } from '../../../../../utils/orders';

const ListCols = ['name', 'countRatePlan', 'stayDate', 'stayDateFrom', 'stayDateTo', 'productType', 'bookDates', 'countBookDate', 'markupType', 'markupValue', 'markupFlightValue', 'isActived'];

const ModelFields = Object.getOwnPropertyNames(new MarkupBundle());

class MarkupBundleList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['stayDateFrom', 'stayDateTo', 'countBookDate']),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    fixed: 'left'
                },
                stayDate: {
                    width: 250,
                    key: 'stayDate',
                    // sorter: (i, k) => i.stayDateTo.length - k.length,
                    render: (value, record) => `${moment(moment.utc(record.stayDateFrom).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)} - ${moment(moment.utc(record.stayDateTo).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)}`
                },
                bookDates: {
                    render: (value, record) => this.renderBookDate(value, record)
                },
                productType: {
                    key: 'productType',
                    render: (value, record) => value && <StatusComponent color={value === 2 ? 'geekblue' : 'red'} label={this.props.t(`item.markupBundle.productTypeLang.${value}`)} />,
                    filters: [
                        { value: 1, text: this.props.t(`item.markupBundle.productTypeLang.1`) },
                        { value: 2, text: this.props.t(`item.markupBundle.productTypeLang.2`) }
                    ],
                },
                markupType: {
                    render: (value, record) => this.props.t(`item.markupBundle.markupTypeLang.${value}`)
                },
                markupValue: {
                    align: 'right',
                    render: (value, record) => record.markupType === 1 ? value : this.renderPrices(
                        value || 0,
                        this.props.t(`currencySymbol`), true
                    )
                },
                markupFlightValue: {
                    align: 'right',
                    render: (value, record) => record.markupType === 1 ? value : this.renderPrices(
                        value || 0,
                        this.props.t(`currencySymbol`), true
                    )
                },
                isActived: {
                    width: 100,
                    key: 'active',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.markupBundle.active') : this.props.t('item.markupBundle.deactive')} />
                    )
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
            expandedRows: [],
            bookDateShow: null,
            markupType: null,
            tableBookingDates: [
                {
                    title: this.props.t('item.markupBundle.bookDateFrom'),
                    dataIndex: 'bookDateFrom',
                    key: 'bookDateFrom',
                    render: (value) => value && moment(moment.utc(value).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                {
                    title: this.props.t('item.markupBundle.bookDateTo'),
                    dataIndex: 'bookDateTo',
                    render: (value) => value && moment(moment.utc(value).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE)
                },
                {
                    title: this.props.t('item.markupBundle.markupValue'),
                    dataIndex: 'markupValue',
                    key: 'markupValue',
                    align: 'right',
                    render: (value, record) => this.state.markupType === 1 ? `${value}%` : this.renderPrices(
                        value || 0,
                        this.props.t(`currencySymbol`), true
                    )
                },
            ]
        };
    }

    render() {
        const { loading, pagination, markupBundles } = this.props;
        const { titleItemTable, modelItem, componentTable, expandedRows, bookDateShow, tableBookingDates } = this.state;
        return (
            <Fragment>
                <ListComponent
                    scroll={{ x: 1300 }}
                    tableKey="markupBundles-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: loading, size: 'large' }}
                    dataSource={Func.getDataSource(markupBundles || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'markupBundle'
                    })}
                    onChange={this.props.onChange}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                    componentTableList={{}}
                    onExpand={this.onRowExpanded}
                    onColumnVisibleChange={this.onColumnVisibleChange}
                    expandedRowKeys={expandedRows}
                    onExpandedRowsChange={expandedRows => this.setState({ expandedRows })}
                />
                <Modal title={this.props.t('item.markupBundle.bookDates')} visible={!!bookDateShow} onOk={this.handleCloseModal} onCancel={this.handleCloseModal}>
                    {
                        !!bookDateShow &&
                        <Table dataSource={bookDateShow} columns={tableBookingDates} rowKey={(record) => generateStringId(10)} />
                    }
                </Modal>
            </Fragment>
        );
    }

    renderPrices(price, currency, quantity) {
        return (
            <Span className="prices">
                {quantity && <Span>{quantity > 1 ? `${quantity}x` : ''}{Func.formatMoney(price)}</Span>} {`${currency || ''}`}
            </Span>
        )
    }

    onRowExpanded = (expanded, record) => {
        if (expanded && record.id) {
            this.props.onItemExpanded(expanded, record)
        }
    }

    handleCloseModal = () => {
        this.setState({ bookDateShow: null })
    }

    renderBookDate = (item, record) => {
        item = item.filter(x => x.status);
        return (
            <Fragment>
                <Span className="cursorPointer" onClick={() => this.setState({ bookDateShow: item, markupType: record.markupType })}>{item.length} Khoảng</Span>
            </Fragment>
        )
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeMarkupBundle = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.category.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeMarkupBundle,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.MARKUP_BUNDLE.DETAIL.path, { id: item.id, type: item.productType === 1 ? 'Hotel' : 'Bundle' })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    componentDidMount() {
        // getColumnVisibleConfigs(ListKeyString, this.state.componentTable);
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        // setColumnVisibleConfigs(ListKeyString, componentTable);
        this.setState({ componentTable })
    }
}

export default withTranslation()(MarkupBundleList);

MarkupBundleList.defaultProps = {
    data: {},
    filters: {},
    loading: false,
    onTableChange: () => { }
}